export const CheckConditionalityHelper = {
    shouldComponentShow(component, answers, childComponents) {
        if (!component?.condition) {
            return true;
        }

        const triggerAnswer = answers.find(a => a.questionId === component.condition.triggerQuestionId);
        if (!triggerAnswer) {
            return false;
        }
        else {
            const triggerComponent = childComponents.find(c => c.id === triggerAnswer.questionId);
            if (!this.shouldComponentShow(triggerComponent, answers, childComponents)) {
                return false;
            }
        }

        switch (triggerAnswer.$answerType) {
            case "Dropdown":
                return this.isConditionMetForYesNo(component.condition, triggerAnswer);
            case "YesNo":
                return this.isConditionMetForYesNo(component.condition, triggerAnswer);
            case "MultiSelect":
                return this.isConditionMetForMultiselect(component.condition, triggerAnswer);
            default:
                return false;
        }
    },

    isConditionMetForYesNo(condition, answer) {
        return answer.answer != null && condition.requiredAnswers.some(c => c.toLowerCase() === answer.answer.toString().toLowerCase());
    },

    isConditionMetForDropdown(condition, answer) {
        return answer.answer != null && condition.requiredAnswers.some(c => c === answer.answer);
    },

    isConditionMetForMultiselect(condition, answer) {
        return answer.answers != null && condition.requiredAnswers.some(c => answer.answers.includes(c));
    }
}